import { render, staticRenderFns } from "./DirectDebit.vue?vue&type=template&id=50a97047&"
import script from "./DirectDebit.vue?vue&type=script&lang=js&"
export * from "./DirectDebit.vue?vue&type=script&lang=js&"
import style0 from "./DirectDebit.vue?vue&type=style&index=0&id=50a97047&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports